import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-recognitions',
    templateUrl: './recognitions.component.html',
    styleUrls: ['./recognitions.component.scss']
})
export class RecognitionsComponent implements OnInit {

    src: string = '/assets/pdf/about/2(F)_12B.pdf';
    constructor() { }

    ngOnInit(): void {
    }

}
